(() => {
  const directionOrder = ['north', 'east', 'south', 'west'];

  const initialiseGuardians = (root) => {
    if (root.dataset.guardiansReady === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[data-guardian-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-guardian-panel]'));
    const details = Array.from(root.querySelectorAll('[data-guardian-detail]'));

    if (!tabs.length || !panels.length || !details.length) return;

    const availableDirections = directionOrder.filter((direction) =>
      tabs.some((tab) => tab.dataset.guardianTab === direction)
    );

    const setActive = (direction, moveFocus = false) => {
      if (!availableDirections.includes(direction)) return;

      root.dataset.activeGuardian = direction;

      tabs.forEach((tab) => {
        const active = tab.dataset.guardianTab === direction;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && moveFocus) tab.focus();
      });

      panels.forEach((panel) => {
        const active = panel.dataset.guardianPanel === direction;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      details.forEach((detail) => {
        const active = detail.dataset.guardianDetail === direction;
        detail.hidden = !active;
        detail.classList.toggle('is-active', active);
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => setActive(tab.dataset.guardianTab));

      tab.addEventListener('keydown', (event) => {
        const currentIndex = availableDirections.indexOf(tab.dataset.guardianTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % availableDirections.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + availableDirections.length) % availableDirections.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = availableDirections.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        setActive(availableDirections[nextIndex], true);
      });
    });

    const initialDirection =
      tabs.find((tab) => tab.getAttribute('aria-selected') === 'true')?.dataset.guardianTab ||
      availableDirections[0];

    setActive(initialDirection);
    root.dataset.guardiansReady = 'true';
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-lg-guardians]').forEach(initialiseGuardians);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
